import type { SVGProps } from 'react';

export const CopyToClipboard = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.8 4.002c-.54.008-.864.039-1.126.172a1.6 1.6 0 0 0-.7.7c-.133.262-.164.586-.172 1.126M18 4.002c.54.008.864.039 1.126.172a1.6 1.6 0 0 1 .7.7c.133.262.165.586.172 1.126m0 7.2c-.008.54-.039.864-.172 1.126a1.6 1.6 0 0 1-.7.7c-.262.133-.586.165-1.126.172M20 8.8v1.6M13.6 4h1.6M6.56 20h6.08c.896 0 1.344 0 1.686-.174a1.6 1.6 0 0 0 .7-.7c.174-.342.174-.79.174-1.686v-6.08c0-.896 0-1.344-.174-1.686a1.6 1.6 0 0 0-.7-.7c-.342-.174-.79-.174-1.686-.174H6.56c-.896 0-1.344 0-1.686.174a1.6 1.6 0 0 0-.7.7C4 10.016 4 10.464 4 11.36v6.08c0 .896 0 1.344.174 1.686a1.6 1.6 0 0 0 .7.7c.342.174.79.174 1.686.174Z"
      />
    </svg>
  );
};
